import React, { Component } from "react";

import styles from "./About.css";

class Mission extends Component {
  render() {
    return (
      <div className={styles.aboutSections}>
        <div className={styles.sectionHeaders}>
          <h4>Our mission</h4>
        </div>

        <div className={styles.aboutContent}>
          <p>
            We are a new media company delivering vital, trustworthy news and analysis in the most efficient, illuminating and shareable ways possible. We offer a mix of original and smartly narrated coverage of media trends, tech, business and politics with expertise, voice AND smart brevity — on a new and innovative mobile platform. At Axios — the Greek word for worthy — we provide only content worthy of people’s time, attention and trust.
          </p>
        </div>
      </div>
    );
  }
}

export default Mission;



// WEBPACK FOOTER //
// ./src/about/components/About/Mission.js